import styled from "styled-components"
import { colors } from "../../themes/colors"

export const GettingStartedWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 64px 24px;
  background-color: ${colors.c_white[500]};

  * {
    font-family: Poppins;
  }

  @media (max-width: 834px) {
    padding: 32px 24px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  h2 {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    line-height: 32px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #1c1e21;
    line-height: 24px;
  }

  @media (max-width: 834px) {
    h2 {
      font-size: 24px;
    }
  }
`

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 32px;
  max-width: 992px;

  @media (max-width: 834px) {
    flex-direction: column;
    gap: 24px;
  }
`

export const Card = styled.div`
  min-width: 200px;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  h4 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #250044;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #4d515a;
  }

  @media (max-width: 834px) {
    max-width: 600px;
    flex-direction: row;
    gap: 16px;
  }
`

export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  margin-bottom: 8px;
  background-color: ${colors.c_primary[50]};

  & > * {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 834px) {
    min-width: 40px;
  }
`

export const ButtonWrapper = styled.div<{ maxWidth?: string }>`
  max-width: ${props => props.maxWidth || "320px"};
  margin: 0 auto;
  width: 100%;
  @media (max-width: 834px) {
    max-width: 600px;
  }
`
